import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const images = [
    "/images/b1.png",
    "/images/b2.png",
    "/images/b3.png",
    "/images/b4.png"
];

// ✨ Hier kommt die `small`-Prop rein
export default function ImageSlider({ small = false }) {
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        fade: true
    };

    return (
        <SliderWrapper>
            <StyledSlider {...settings}>
                {images.map((img, index) => (
                    <Slide key={index} small={small}>
                        <Image src={img} alt={`Slide ${index + 1}`} />
                    </Slide>
                ))}
            </StyledSlider>
        </SliderWrapper>
    );
}

// Wrapper für Styling drumherum (wie bisher)
const SliderWrapper = styled.div`
    margin-bottom: 3rem;
    border-radius: 2px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
`;

// ✨ Höhe jetzt per Prop steuerbar
const Slide = styled.div`
    width: 100%;
    height: ${({ small }) => (small ? '200px' : '400px')};

    @media (max-width: 768px) {
        height: ${({ small }) => (small ? '150px' : '250px')};
    }
`;

const StyledSlider = styled(Slider)`
    .slick-dots li button:before {
        color: #344E97;
    }

    .slick-prev:before,
    .slick-next:before {
        color: #344E97;
    }
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;

    &:hover {
        transform: scale(1.03);
    }
`;
